module.exports = __webpack_public_path__ + "ru.svg?80428218456fc95fa176f1ebdaeba60d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ru.svg
// module id = 924
// module chunks = 27